/**
 * Created by Ning Jiang on 2/7/2018.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Linear, Power2, SlowMo, Timeline, TimelineLite, TweenLite} from "gsap";
import {DualLayerBitmapCountUp} from "../../../bitmapcountup/DualLayerBitmapCountUp";
import {TweenParticleEmitter} from "../../../tweenparticles/TweenParticleEmitter";
import {TractorBeamGameConfig} from "../../TractorBeamGameConfig";
import {TractorBeamSoundConfig} from "../../TractorBeamSoundConfig";

export class TractorBeamBigWinView extends BaseView {

    private leftBigWinParticleConfig:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 1.5,
                "end" : 1.8,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -75,
                "max" : -80
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 3.1,
                "max" : 4.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : 720,// 840,
                "h" : 100//300
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 1.5,
                "end" : 1.8,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -75,
                "max" : -80
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 3.1,
                "max" : 4.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : 720,// 840,
                "h" : 100//300
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 1.5,
                "end" : 1.8,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -75,
                "max" : -80
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 3.1,
                "max" : 4.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : 720,// 840,
                "h" : 100//300
            }
        }
    ];
    private rightBigWinParticleConfig:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 1.5,
                "end" : 1.8,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -100,
                "max" : -105
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 3.1,
                "max" : 4.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : -500,//-840,
                "h" : 100//300
            }

        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 1.5,
                "end" : 1.8,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -100,
                "max" : -105
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 3.1,
                "max" : 4.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : -500,//-840,
                "h" : 100//300
            }

        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 1.5,
                "end" : 1.8,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -100,
                "max" : -105
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 3.1,
                "max" : 4.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : -500,//-840,
                "h" : 100//300
            }

        }
    ];

    private BIG_WIN_DISPLAY_NUMBERS:BitmapTextStyleOptions = {
        font : {
            name : "yetiCountUp",
            size : 150
        },
        tint : 0xffffff
    };
    private BIG_WIN_DISPLAY_NUMBERS_WHITE:BitmapTextStyleOptions = {
        font : {
            name : "yetiCountUpWhite",
            size : 150
        },
        tint : 0xffffff
    };

    private _currentBwImg:PIXI.Sprite;
    private _bigWinImages:PIXI.Sprite [] = [];

    private _texts:string [] = ["First Contact!", "Otherworldly!", "Extraterrestrial!"];
    private _isShowing:boolean = false;
    private _dimmer:PIXI.Graphics;

    // Coin "particles"
    private _flare:PIXI.Sprite;
    private _leftParticles:TweenParticleEmitter [];
    private _rightParticles:TweenParticleEmitter [];
    private _particleBackground:PIXI.Container;
    private _particleForeground:PIXI.Container;

    private _bigWinText:PIXI.Sprite;
    private readonly _textTextureNames:string[] = [];
    private _particleAnimation:TimelineLite;
    private _countUpText:DualLayerBitmapCountUp;
    private _countContainer:PIXI.Container;
    private _hueTimeline:Timeline;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(TractorBeamGameConfig.instance.LAYERS.BIG_WIN.name);
    }

    protected initAnimations():void {
        this._bigWinImages = [
            new PIXI.Sprite(GameResources.getTextures("bigWinLvl1")[0]),
            new PIXI.Sprite(GameResources.getTextures("bigWinLvl2")[0]),
            new PIXI.Sprite(GameResources.getTextures("bigWinLvl3")[0])
        ];

        const colorMatrix = new PIXI.filters.ColorMatrixFilter();

        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;

        /*this._placeHolderText = new PIXI.Text("", {
            fontSize : 102,
            fill: 0x7AD7F0,
            stroke: 0xFFFFFF,
            lineJoin: "bevel",
            strokeThickness: 8,
            miterLimit: 2,
            dropShadow: true,
            "dropShadowAngle": 1.5
        });
        this._placeHolderText.anchor.set(0.5, 0.5);
        this._placeHolderText.position.set(660, 170);
        this._placeHolderText.alpha = 0;*/

        this._currentBwImg = new PIXI.Sprite();
        this._currentBwImg.anchor.set(0.5, 0.5);
        this._currentBwImg.position.set(665, 278);
        this._currentBwImg.alpha = 0;
        this._currentBwImg.scale.set(1.2, 1.2);

        [0, 1, 2].forEach((value) => {
            const bwImg:PIXI.Sprite = this._bigWinImages[value];
            bwImg.name = "bw" + value;
            bwImg.anchor.set(0.5, 0.5);
            bwImg.visible = false;
            this._currentBwImg.addChild(bwImg);
        });
        //

        this._particleBackground = new PIXI.Container();
        this._particleBackground.name = "_particleBackground";

        this._particleForeground = new PIXI.Container();
        this._particleForeground.name = "_particleForeground";

        this.createParticles(this._particleBackground, this._particleForeground);

        // bg flare
        this._flare = new PIXI.Sprite(GameResources.getTextures("bwbg")[0]);
        this._flare.blendMode = PIXI.BLEND_MODES.ADD;
        this._flare.anchor.set(0.5, 0.38);
        this._flare.position.set(670, 300);
        this._flare.alpha = 0;
        this._flare.scale.set(0);
        //this._flare.tint = 0x92DFF3;


        // TODO: atm unused
        this._bigWinText = new PIXI.Sprite();
        this._bigWinText.anchor.set(0.5, 0.5);
        this._bigWinText.position.set(360, 300);

        //*********Count up
        this._countContainer = new PIXI.Container();
        this._countUpText = new DualLayerBitmapCountUp(this.BIG_WIN_DISPLAY_NUMBERS_WHITE, this.BIG_WIN_DISPLAY_NUMBERS, 550, new PIXI.Point(0.5, 0.5));
        this._countUpText.getFadeOutTopLayer(0.001);

        let sub:boolean = true;
        let hueCounter:number = 0;
        this._countContainer.filters = [colorMatrix];
        //colorMatrix.hue(135);
        //colorMatrix.blendMode = PIXI.BLEND_MODES.SCREEN;
        //colorMatrix.saturate(1, true);

        /*this._hueTimeline = new TimelineMax({repeat: -1}).add( // yoyo
            () => {
                if(hueCounter > 135) { // -165
                    hueCounter = 135;
                    sub = true;
                }

                if(hueCounter < 60) {
                    hueCounter = 60;
                    sub = false;
                }

                if(sub) {
                    colorMatrix.hue(hueCounter-=2.5); // +=5
                }
                else {
                    colorMatrix.hue(hueCounter+=2.5); // +=5
                }
            }, 0.066);*/


        this._countContainer.addChild(this._countUpText);
        this._countContainer.scale.set(0);
        this._countContainer.position.set(660, 438);

        this.addChild(this._particleBackground);
        this._layer.addChild(this._dimmer);
        this.addChild(this._flare);

        //this.addChild(this._plateParticles);
        this.addChild(this._bigWinText);
        //this.addChild(this._placeHolderText);
        this.addChild(this._currentBwImg);

        this.addChild(this._particleForeground);

        this.addChild(this._countContainer);

        this._layer.addChild(this);
        this.visible = true;
    }

    protected onResize(resizeData:IResizeData):void {
        if(!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;
        const screenWidth:number = Math.ceil(resizeData.width / this._layer.scale.x);
        const screenHeight:number = Math.ceil(resizeData.height / this._layer.scale.y);
        const leftOffset:number = Math.floor(-this._layer.x / this._layer.scale.x);
        const topOffset:number = Math.floor(-this._layer.y / this._layer.scale.y);

        // TODO: Remove
        this._dimmer.clear();
        //40% opacity , #083656
        this._dimmer.beginFill(0x083656, 0.6);
        this._dimmer.drawRect(leftOffset, topOffset, screenWidth, screenHeight);
    }

    private createParticles(background:PIXI.Container, foreground:PIXI.Container) {
        const particleTextures:any = [
            GameResources.getTextures("coinSprite")[0],
            GameResources.getTextures("coinSprite")[1],
            GameResources.getTextures("coinSprite")[17],
            GameResources.getTextures("coinSprite")[18]
        ];

        this._leftParticles = [];
        this._rightParticles = [];
        const emitterCount:number = 3;
        for(let i:number = 0; i < emitterCount; i++) {
            this.leftBigWinParticleConfig[i].pos.x = -TractorBeamGameConfig.instance.REEL_AREA_WIDTH * 0.5;
            this.leftBigWinParticleConfig[i].pos.y = TractorBeamGameConfig.instance.REEL_AREA_HEIGHT;
            this.leftBigWinParticleConfig[i].scale.start = 1 + (0.05 * i);
            this.leftBigWinParticleConfig[i].scale.end = 1 + (0.05 * i);
            const left:TweenParticleEmitter = new TweenParticleEmitter(particleTextures, this.leftBigWinParticleConfig[i]);

            this.rightBigWinParticleConfig[i].pos.x = TractorBeamGameConfig.instance.REEL_AREA_WIDTH * 1.75;
            this.rightBigWinParticleConfig[i].pos.y = TractorBeamGameConfig.instance.REEL_AREA_HEIGHT;
            this.rightBigWinParticleConfig[i].scale.start = 1 + (0.05 * i);
            this.rightBigWinParticleConfig[i].scale.end = 1 + (0.05 * i);
            const right:TweenParticleEmitter = new TweenParticleEmitter(particleTextures, this.rightBigWinParticleConfig[i]);

            this._leftParticles.push(left);
            this._rightParticles.push(right);

            if(i > emitterCount * 0.5) {
                foreground.addChild(left);
                foreground.addChild(right);
            } else {
                background.addChild(left);
                background.addChild(right);
            }
        }
    }

    private updateWinText(level:number) {
        this._bigWinText.texture = GameResources.getTextures(this._textTextureNames[level])[0];
    }

    private resetIntro() {
        this.scale.set(1, 1);
        this._bigWinText.scale.set(0);
        this._bigWinText.alpha = 0;
        this._flare.alpha = 0;
        this._flare.scale.set(0);
        this._countContainer.scale.set(0);
        //this._hueTimeline.pause(0);
        this._leftParticles.forEach((emitter:TweenParticleEmitter) => {
            emitter.stop(true);
        });
        this._rightParticles.forEach((emitter:TweenParticleEmitter) => {
            emitter.stop(true);
        });
    }

    private getCountUpWhiteFlash(duration:number, startDurationFactor:number = 0.1, holdFactor:number = 0.3):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._countUpText.getFadeInTopLayer(duration * startDurationFactor));
        tl.add(this._countUpText.getFadeOutTopLayer(duration * (1 - startDurationFactor - holdFactor)), duration * holdFactor);
        return tl;
    }

    public getCountUp(from:number, to:number, duration:number):TimelineLite {
        return this._countUpText.getCountAnimation(from, to, duration);
    }

    public getBigWinLevelAnimation(level:number, lastLevel:boolean):TimelineLite {
        this._isShowing = true;
        if(this._isResizeDirty) {
            this.onResize(this._resizeData);
        }

        const tl:TimelineLite = new TimelineLite();

        tl.add([
            () => {
                this.updateBigWinLevelAnimation(level);
            }
        ]);

        let pumpDur:number = 0;
        //let eightBarLength:number = 7.48;
        const barLength = 0.935;
        switch(level) {
            case 0:
                // 0.4 => Longer pump start, music start after pump start.
                // - 0.1 => Start time for the next level.
                //this._hueTimeline.play(0);
                pumpDur = TractorBeamGameConfig.instance.WIN_RATIOS.bigWin[0].duration;
                break;
            case 1:
                pumpDur = TractorBeamGameConfig.instance.WIN_RATIOS.bigWin[1].duration;
                break;
            case 2:
                pumpDur = TractorBeamGameConfig.instance.WIN_RATIOS.bigWin[2].duration;
                break;
            default:
                pumpDur = 0;
                break;

        }


        if(level == 0) {
            tl.add([
                //() => this._placeHolderText.visible = true,
                () => this._currentBwImg.visible = true,
                () => this._particleAnimation = this.getParticleAnimation(4, level),
                TweenLite.to(this._currentBwImg, 0.4, {alpha : 1})
            ]);
        }

        tl.add([
            this.getPumpAnimation(pumpDur, level, lastLevel, 0.9)
        ]);

        return tl;
    }


    private updateBigWinLevelAnimation(level:number):void {
        let text:string = "";
        switch(level) {
            case 0:
                //text = this._texts[level];

                (<PIXI.Sprite[]>this._currentBwImg.children).forEach((child:PIXI.Sprite) => {
                    child.visible = false;
                });
                this._currentBwImg.getChildByName("bw" + level).visible = true;
                break;
            case 1:
                //text = this._texts[level];
                //this._currentBwImg = this._bigWinImages[level];
                (<PIXI.Sprite[]>this._currentBwImg.children).forEach((child:PIXI.Sprite) => {
                    child.visible = false;
                });
                this._currentBwImg.getChildByName("bw" + level).visible = true;
                break;
            case 2:
                //text = this._texts[level];
                //this._currentBwImg = this._bigWinImages[level];
                (<PIXI.Sprite[]>this._currentBwImg.children).forEach((child:PIXI.Sprite) => {
                    child.visible = false;
                });
                this._currentBwImg.getChildByName("bw" + level).visible = true;
                break;
            default:
                //text = "";
                //this._currentBwImg = new PIXI.Sprite();
                break;
        }

        //this._placeHolderText.text = text;
    }

    public getFadeOutAllAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let dur = 1;


        dur *= 0.5;
        tl.add([
            new TweenLite(this._bigWinText, dur, {alpha : 0, ease : Power2.easeIn}),
            new TweenLite(this._countContainer, dur, {alpha : 0, ease : Power2.easeIn}),
            //TweenLite.fromTo(this._placeHolderText, dur, {alpha : 1}, {alpha : 0}),
            TweenLite.fromTo(this._currentBwImg, dur, {alpha : 1}, {alpha : 0}),
            TweenLite.to(this._dimmer, 0.1, {alpha : 0}),
        ], dur);

        return tl;
    }

    public playEndingAnimation(endWinRatioConfig:IWinRatioConfig):void { // TODO: Remove
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            TweenLite.to(this._dimmer, 0.1, {alpha : 0}),
            TweenLite.fromTo(this._currentBwImg, 0.2, {alpha : 1}, {alpha : 0, delay : 0.5})
            //TweenLite.fromTo(this._placeHolderText, 0.2, {alpha : 1}, {alpha : 0, delay : 0.5})
        ]);
        timeline.add(() => this._isShowing = false);

        timeline.play();
    }

    private getPumpMiddle(duration:number, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._bigWinText.scale, duration, {
                x : defaultScale,
                y : defaultScale,
                ease : Linear.easeNone
            }),
            new TweenLite(this._flare.scale, duration, {
                x : defaultScale * 1.5,
                y : defaultScale * 1.5,
                ease : Linear.easeNone
            }),
            new TweenLite(this._countContainer.scale, duration, {
                x : defaultScale,
                y : defaultScale,
                ease : Linear.easeNone
            })
        ]);
        return tl;
    }

    private getPumpAnimation(duration:number, level:number, lastLevel:boolean, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let startDur:number = level == 0 ? 0.4 : 0.1;
        let endDur:number = lastLevel ? 0 : 1.87;
        let middleDur:number = duration - startDur - endDur;

        tl.add(() => this._bigWinText.scale.set(0));
        tl.add(this.getPumpStart(startDur, defaultScale, level));

        const landingTime:number = tl.totalDuration();

        tl.add([
            this.getPumpMiddle(middleDur, defaultScale)
        ]);

        tl.add([
            () => this.getCountUpWhiteFlash(1),
        ], landingTime);


        if(!lastLevel) {
            tl.add(this.getPumpEnd(endDur, defaultScale));
            tl.add(() => this._particleAnimation = this.getParticleAnimation(4, level + 1), "-=0.3");
        }

        //tl.add(DungeonQuest.reelAreaEffectController.fadeInDarkenPlate(middleDur), landingTime);


        return tl;
    }

    private getPumpStart(duration:number, defaultScale:number, level:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            (level === 0) ? () => SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.BIG_WIN) : () => {},
            (level === 0) ? () => SlotGame.sound.fadeAmbience(0, TractorBeamGameConfig.instance.BIG_WIN_FADE_OUT_TIMING_MS) : () => {},
            (level === 0) ? TweenLite.to(this._dimmer, 0.1, {alpha : 0.5}) : () => {},
            new TweenLite(this._bigWinText, duration * 0.5, {alpha : 1}),
            new TweenLite(this._bigWinText.scale, duration, {
                x : defaultScale * 0.80,
                y : defaultScale * 0.80,
                ease : Power2.easeIn
            }),
            /*new TweenLite(this._plateParticles, duration * 0.2, {alpha : 1}),
            new TweenLite(this._plateParticles.scale, duration, {
                x : defaultScale * 0.80,
                y : defaultScale * 0.80,
                ease : Power2.easeIn
            }),*/
            new TweenLite(this._flare, duration * 0.5, {alpha : 1}),
            new TweenLite(this._flare.scale, duration, {
                x : defaultScale,
                y : defaultScale,
                ease : Power2.easeIn
            }),
            new TweenLite(this._countContainer, duration * 0.5, {alpha : 1}),
            new TweenLite(this._countContainer.scale, duration, {
                x : defaultScale * 0.9,
                y : defaultScale * 0.9,
                ease : Power2.easeIn
            })
        ]);
        return tl;
    }

    public getEndingAnimation(isAborted:boolean, level:number, totalAmount:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        //if(isAborted) {
        if(this._particleAnimation && this._particleAnimation.isActive()) {
            this._particleAnimation.timeScale(3);
        }
        //}

        const delay:number = isAborted ? 0.1 : 0.0;
        //tl.add(() => this._sparkRect.clearSparks());
        tl.add(this.getSetToEndStateAnimation(level, totalAmount));
        tl.add([
            () => this.updateBigWinLevelAnimation(level),
            () => SlotGame.sound.stopEffect(TractorBeamSoundConfig.instance.BIG_WIN),
            () => SlotGame.sound.playEffect("bigwinEnds" + (level + 1).toString()),
            () => SlotGame.sound.fadeAmbience(1, TractorBeamGameConfig.instance.BIG_WIN_FADE_IN_TIMING_MS),
            this.getFadeOutAllAnimation()
        ], delay);
        tl.add(() => this.resetIntro());
        //tl.add(() => this.shakeEffect.stopShake());


        return tl;
    }

    public getSetToEndStateAnimation(level:number, totalAmount:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => this._countUpText.stopAt(totalAmount),

        ]);

        const dur = 0.15;
        tl.add([
            () => this.getCountUpWhiteFlash(1),
            new TweenLite(this._bigWinText, dur, {alpha : 1, ease : Linear.easeOut}),
            new TweenLite(this._countContainer, dur, {alpha : 1, ease : Linear.easeOut}),
            new TweenLite(this._flare, dur, {alpha : 1, ease : Linear.easeOut}),

            new TweenLite(this._bigWinText.scale, dur, {x : 1, y : 1, ease : Power2.easeIn}),
            new TweenLite(this._flare.scale, dur, {x : 1.5, y : 1.5, ease : Power2.easeIn}),
            new TweenLite(this._countContainer.scale, dur, {x : 1, y : 1, ease : Power2.easeIn})
        ]);


        return tl;
    }

    private getParticleAnimation(countDuration:number, level:number):TimelineLite {
        const maxParticles = (level + 1);

        let tl:TimelineLite = new TimelineLite();

        for(let i:number = 0; i < this._leftParticles.length; i++) {

            const depthMaxCount = maxParticles * (this._leftParticles.length - i);
            let leftParticle = this._leftParticles[i];
            let rightParticle = this._rightParticles[i];

            tl.add(() => this.setParticlesProperty(i, level, depthMaxCount), 0);
            tl.add(() => leftParticle.start(SlowMo.ease.config(0.3, 0.8, false)), 0.3);
            tl.add(() => rightParticle.start(SlowMo.ease.config(0.3, 0.8, false)), 0.3);
        }
        tl.add(() => countDuration - 0.7 + 0.3);

        return tl;
    }

    private getPumpEnd(duration:number, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._countContainer.scale, duration, {
                x : defaultScale * 0.65,
                y : defaultScale * 0.65,
                ease : Power2.easeInOut
            })
        ]);


        tl.add([
            new TweenLite(this._bigWinText, 0.2, {alpha : 0.0, ease : Linear.easeNone}),
            new TweenLite(this._bigWinText.scale, 0.4, {
                x : defaultScale * 0.9,
                y : defaultScale * 0.9,
                ease : Power2.easeIn
            }),
            new TweenLite(this._flare, 0.2, {alpha : 0.0, ease : Linear.easeNone}),
            new TweenLite(this._flare.scale, 0.4, {
                x : 0,
                y : 0,
                ease : Power2.easeIn
            })
        ], "-=0.4");
        return tl;
    }

    private setParticlesProperty(index:number, level:number, maxParticles:number) {
        let baseScale:number;
        let depthFactor:number;
        let startColor:string;
        let endColor:string;
        let endScaleFactor:number;


        switch(level) {
            case 0:
                baseScale = 0.7;

                break;
            case 1:
                baseScale = 0.7;

                break;
            default:
                baseScale = 0.7;

        }

        startColor = "#aea2bf";
        switch(index) {
            case 0:
                //endColor = "#9b88d7";
                //startColor = "#9b88d7";
                depthFactor = 1;
                endScaleFactor = 0.8;
                break;
            case 1:
                //startColor = "#aea2bf";
                //endColor = startColor;
                depthFactor = 1;
                endScaleFactor = 1.5;
                break;
            default:
                //startColor = "#ffffff";
                //endColor = "#ffffff";
                depthFactor = 1;
                endScaleFactor = 2.5;
        }


        const startScale = baseScale * depthFactor;
        const endScale = startScale * endScaleFactor;


        //ParticleUtils.hexToRGB(startColor, <[number, number, number]> this._leftParticles[index].emitter.startColor);
        //ParticleUtils.hexToRGB(endColor, <[number, number, number]> this._leftParticles[index].emitter.endColor);
        this._leftParticles[index].emitterConfig.scale.start = startScale;
        this._leftParticles[index].emitterConfig.scale.end = endScale;
        this._leftParticles[index].emitterConfig.maxParticles = maxParticles;
        this._leftParticles[index].updateConfig();

        //ParticleUtils.hexToRGB(startColor, <[number, number, number]> this._rightParticles[index].emitter.startColor);
        //ParticleUtils.hexToRGB(endColor, <[number, number, number]> this._rightParticles[index].emitter.endColor);
        this._rightParticles[index].emitterConfig.scale.start = startScale;
        this._rightParticles[index].emitterConfig.scale.end = endScale;
        this._rightParticles[index].emitterConfig.maxParticles = maxParticles;
        this._rightParticles[index].updateConfig();
    }

    public preCalculateCountScale(totalWin:number) {
        this._countUpText.preCalculateScale(0, totalWin);
    }
}
